import React from 'react';
import oneDine from '@assets/images/oneDineLogoM.png';
import TextField from '@components/common/formElements/TextFieldFormik';
import { Form, Formik } from 'formik';
import style from './activation.module.scss';
import cn from 'classnames';
import * as Yup from 'yup';

const Activation = (props) => {

  // Props Destructuring

  const {activate} = props;

  // Methods

  const handleSubmit = (data) => {
    activate(data);
  };

  // Validations

  const validateCode = () => (
    Yup.object().shape({
      activationCode: Yup.string().required('Code is Required')
        .min(6, 'Code should be 6-digit')
        .max(6, 'Code should be 6-digit')
        .nullable(),
    })
  );

  // HTML CSS Code

  return (
    <div className="col-12 page">
      <div className="row m-0 py-1 justify-content-center align-items-center">
        <img src={oneDine} width="150px" alt="onedine" />
      </div>
      <div className="row m-0 pt-3 pb-3 fw-500 fs-16 text-center justify-content-center align-items-center">Please enter the 6-digit activation you received from the OneDine Portal</div>
      <div className="row m-0 py-1 justify-content-center align-items-center">
        <div className="col-12 col-lg-4 col-xl-4 col-md-4 col-sm-4">
          <Formik
            initialValues={{ activationCode: '' }}
            validationSchema={validateCode}
            onSubmit={handleSubmit}
          >
            <Form className="row m-0 p-0">
              <div className="col-10 p-0">
                <TextField
                  name="activationCode"
                  type="text"
                />
              </div>
              <div className="col-2 pl-2 pt-2">
                <button type="submit" className={cn(style.btnContent)}>
                  <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAgCAYAAAB3j6rJAAAAAXNSR0IArs4c6QAAAppJREFUWAm9l79rE2EYx3NJdInidIOgSAdFcFP8B1pEzC+awygWdKngYMFFHVzq4iB06iCOoV2UgDE/bcFFcXAQ3UUHEaKDg0NDEzE5P4/0DW9eL0dt3tzBy3vP8+Se7+ee57m7NhazeKTT6Rt7TRff64VjrlvMZrM3x8RC3VZBHMf55vv+KpW5FKoaELQKAkSbFQdoncrMBeiNdVkFkYqIEjD7WZVMJnNmrLIRsAoSj8fbKj8gB1kvqMxx5QvbrYIgPATZEXXxbXqedzgMQmJWQQaDgQkibZrpdrsbxWLxUBiMw4S/D/vB/8SYEZmNU0HXEHvtuu75UqnUDYwD4gcFpuR7nkqlLpbL5b6Z32przOQB9nyn03kc4Lc7I0ECtGTL8F/nsX5g+GIyIyOtSSaTp80fTWIzM9sM8Qb7MSPPrVartap8/4AQdFTQ1l4oFE70er035HO1nD7VWmg2m0/EF8mMVCqVj1Q6bbTJoUpr+Xz+XGQgIlSr1d4lEgkPmF9i7xz7+v3+s1wudzaSiijVarX6kiq8Urbs2AeYoZVIQfjuyHD+bYUG85lKXYkMhKfzIXe/pAHI6VfWHG1rRwICxDKCd0VZHczKdwZ4lqf0i/imDsLL6zY690VMHUD8AEIq8WnoM19o/E2xroKT7rQixfL0PED8ZCZmgfig+5O6IedM8FXTZ8sGYosbvWBCSP6pt0bdBBDbQGTr9fpb5dP3qEB6iBaAGHmH6CDSmmu6Y5Jz7vokM3HPyPEb+zLflE3DP2Ja/cAx+PL/zFOlANiAtdBoNIY+FTN3q61hBo5oAhTHX9wNhFxjFQThIQiVWOJlVdLAQk+tgqB0VNSAuMNMPApVNoJWQaQiQCwDsWLoRGvydTU/arsG+ANQb+Rs/2etSgAAAABJRU5ErkJggg==" alt="btn" />
                </button>
              </div>
            </Form>
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default Activation;
